<template>
  <section class="assessmentSection">
    <ProgressBar :value="15" />
    <div class="pageContent">
      <div class="pageTitle">What kind of features are you looking for?</div>
      <div
        class="pageSubtitle"
      >Are you the type of person to want all the bells and whistles, or does just the best home security do the trick?</div>

      <div class="options">
        <TruePanel class="p-4 cursor-pointer mb-4 flex" @click.native="handlePanelClick('traditional')">
          <div class="flex flex-col justify-center">
            <div class="text-bold pb-4 font-18px">
            I’m just looking for
            <span class="text-blue">traditional home security</span>
          </div>
          <div>Just the basics for protecting your home and family, along with professional monitoring.</div>
          </div>
          <div class="icon">
            <i class="fa fa-chevron-right"></i>
          </div>
        </TruePanel>

        <TruePanel class="p-4 cursor-pointer mb-4 flex" @click.native="handlePanelClick('cameras')">
          <div class="flex flex-col justify-center">
            <div class="text-bold pb-4 font-18px">
            I want
            <span class="text-blue">Security + Cameras</span>
          </div>
          <div>I’m interested in capturing video and peaking into my house from my phone.</div>
          </div>
          <div class="icon">
            <i class="fa fa-chevron-right"></i>
          </div>
        </TruePanel>

        <TruePanel
          class="p-4 cursor-pointer mb-4 flex"
          @click.native="handlePanelClick('home-automation')"
        >
          <div class="flex flex-col justify-center">
            <div class="text-bold pb-4 font-18px">
            I want
            <span class="text-blue">Security + Home automation</span>
          </div>
          <div>I want to control my lights, thermostats, and even my doors through my smart phone.</div>
          </div>
          <div class="icon">
            <i class="fa fa-chevron-right"></i>
          </div>
        </TruePanel>

        <TruePanel class="p-4 cursor-pointer mb-4 flex" @click.native="handlePanelClick('total')">
          <div class="flex flex-col justify-center">
            <div class="text-bold pb-4 font-18px">
            I want it all
            <span class="text-blue">Security + Cameras + Home automation</span>
          </div>
          <div>I want everything you have to offer.</div>
          </div>
          <div class="icon">
            <i class="fa fa-chevron-right"></i>
          </div>
        </TruePanel>
      </div>
    </div>
  </section>
</template>


<script>
import { mapActions } from 'vuex'
import TruePanel from "../components/TruePanel.vue";
import ProgressBar from '../components/ProgressBar.vue'

export default {
  components: {
    TruePanel,
    ProgressBar
  },

  methods: {
    ...mapActions(['selectProtectionLevel']),

    handlePanelClick(type) {
      const typeMap = {
        traditional: "/system",
        cameras: "/cameras",
        "home-automation": "/home-automation",
        total: "/cameras"
      };

      this.selectProtectionLevel(type)

      this.$router.push(typeMap[type])

    }
  }
};
</script>

<style lang="scss" scoped>
.pageContent {
  max-width: 800px;
  line-height: 1.375;
}

.pageTitle {
  max-width: 340px;
}

.pageSubtitle {
  max-width: 415px;
}

.font-18px {
  font-size: 18px;
}

.icon {
  display: flex;
  place-items: center;
  font-size: 27px;
  color: #A7A7A7;
  padding-left: 70px;
  @media (max-width: 768px) {
    padding-left: 20px;
  }
}

.options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  @media (max-width: 768px) {
    display: block;
  }
}

</style>
